import createStore from './create-store'

/**
 * Caches store for later use
 */
const store = createStore()

export default store
